import type { PriceListRatioCoefficientRowData } from 'gql/graphql';
import { Loader } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import React from 'react';

import { PriceListFactorsRowMenu } from '../PriceListFactorsRowMenu/PriceListFactorsRowMenu';

export const FactorsMenuCellRendererComponent = ({ data }: ICellRendererParams<PriceListRatioCoefficientRowData>) => {
    if (!data) {
        return <Loader />;
    }

    return <PriceListFactorsRowMenu row={data} />;
};

FactorsMenuCellRendererComponent.displayName = 'FactorsMenuCellRendererComponent';
